const SUCCESS_STATUS = "SUCCESS";
const NO_PRN_GALILEO_STATUS =
  "GraphQL error: Cannot read property 'dataValues' of null";
const ERROR_MESSAGE = "Unable to update user names.";
const GALILEO_WARNING =
  "Galileo credentials not found for user. This is expected for non-approved users.";

export {
  SUCCESS_STATUS,
  ERROR_MESSAGE,
  NO_PRN_GALILEO_STATUS,
  GALILEO_WARNING
};
